/**
 * The plan feature table and the public-widget plan gate — the ONE copy both
 * the client and the Cloud Functions run.
 *
 * WHY THE SERVER NEEDS THE TABLE. The widget snapshot (`publicWidget.js`)
 * publishes a `features` block the embed reads to decide which sub-widgets to
 * render; the admin's embed builder gates the same widgets on the client.
 * Until the 2026-09 audit follow-up (D3) the server hard-wired
 * `publicWidget: true` and gated `grades` and `competition` on "pro or
 * competition" — while the table says the Pro plan has NO competitions. A Pro
 * gym's embed offered a competition widget that could never have anything to
 * show. The gate is one rule now, keyed on this one table.
 */

/** Multi-gym plan feature gates: what each plan may use, and its limits. */
export const PLAN_FEATURES = {
  free: {
    tvDashboard: false, friends: false, competitions: false, events: false,
    customBranding: false, dbMaintenance: false, setterStats: false, gymPwa: false,
    advancedStats: false, publicWidget: true,
    maxMaps: 1, maxRoutes: 50,
  },
  pro: {
    tvDashboard: true, friends: true, competitions: false, events: true,
    customBranding: true, dbMaintenance: true, setterStats: true, gymPwa: true,
    advancedStats: true, publicWidget: true,
    maxMaps: 5, maxRoutes: 500,
  },
  competition: {
    tvDashboard: true, friends: true, competitions: true, events: true,
    customBranding: true, dbMaintenance: true, setterStats: true, gymPwa: true,
    advancedStats: true, publicWidget: true,
    maxMaps: 10, maxRoutes: null,
  },
};

const PRO_PLUS = new Set(["pro", "competition"]);

/**
 * Which embed widgets a plan may use:
 * - `summary`: all plans
 * - `full`: always allowed (renders sub-widgets with their own gating)
 * - `grades`, `occupancy`: Pro+ only
 * - `competition`: plans whose feature table includes competitions
 */
export function widgetAvailableForPlan(widget, plan) {
  if (widget === "summary" || widget === "full") return true;
  if (widget === "grades" || widget === "occupancy") return PRO_PLUS.has(plan);
  if (widget === "competition") return !!(PLAN_FEATURES[plan] && PLAN_FEATURES[plan].competitions);
  return false;
}
